/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { IExampleParent } from '../../core/models/common/IExampleParent';

/**
 * A command used to set the Example for a 3.0 MediaType or a 2.0 Response.
 * @author eric.wittmann@gmail.com
 * @extends AbstractCommand
 * @class
 */
export abstract class SetExampleCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _newExample : any;

    public _oldValue : any;

    public constructor(parent? : any, example? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExampleParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.core.models.common.IExampleParent") >= 0)) || parent === null) && ((example != null) || example === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
                this._newExample = example;
            })();
        } else if(parent === undefined && example === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._newExample===undefined) this._newExample = null;
            if(this._oldValue===undefined) this._oldValue = null;
        } else throw new Error('invalid overload');
    }
}
SetExampleCommand["__class"] = "io.apicurio.datamodels.cmd.commands.SetExampleCommand";
SetExampleCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];





import { MarshallCompat } from '../../compat/MarshallCompat';

